import {
  SectionElement,
  defineElement,
  on,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-custom-join/shop-custom-join.ts
var ShopCustomJoin = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.storageKey = "shop-custom-join:remember";
    this.joinInitialized = false;
  }
  connectedCallback() {
    if (!this.rememberCheckbox) {
      return;
    }
    const shouldAutoLoad = this.getStoredPreference();
    if (!shouldAutoLoad) {
      return;
    }
    this.rememberCheckbox.checked = true;
    if (this.ensureJoinReady()) {
      this.toggleContent();
    }
  }
  handleConsentClick(_button, event) {
    event.preventDefault();
    this.storePreference();
    if (this.ensureJoinReady()) {
      this.toggleContent();
    }
  }
  mountJoinWidget(joinUrl) {
    this.joinContent.innerHTML = "";
    const widgetContainer = document.createElement("div");
    widgetContainer.id = "join-widget";
    const script = document.createElement("script");
    script.defer = true;
    script.type = "text/javascript";
    script.setAttribute("data-mount-in", "#join-widget");
    script.src = joinUrl;
    widgetContainer.appendChild(script);
    this.joinContent.appendChild(widgetContainer);
  }
  ensureJoinReady() {
    if (this.joinInitialized) {
      return true;
    }
    const joinUrl = this.joinScriptTarget.dataset.joinScriptUrl;
    if (!joinUrl) {
      console.warn("shop-custom-join: Missing join script url.");
      return false;
    }
    this.mountJoinWidget(joinUrl);
    this.joinInitialized = true;
    return true;
  }
  toggleContent() {
    this.consentContent.classList.add("hidden");
    this.joinContent.classList.remove("hidden");
  }
  getStoredPreference() {
    try {
      return window.sessionStorage.getItem(this.storageKey) === "true";
    } catch (error) {
      console.warn("shop-custom-join: Unable to access sessionStorage.", error);
      return false;
    }
  }
  storePreference() {
    if (!this.rememberCheckbox) {
      return;
    }
    try {
      if (this.rememberCheckbox.checked) {
        window.sessionStorage.setItem(this.storageKey, "true");
      } else {
        window.sessionStorage.removeItem(this.storageKey);
      }
    } catch (error) {
      console.warn("shop-custom-join: Unable to persist sessionStorage preference.", error);
    }
  }
};
__decorateClass([
  query("[data-consent-content]")
], ShopCustomJoin.prototype, "consentContent", 2);
__decorateClass([
  query("[data-join-content]")
], ShopCustomJoin.prototype, "joinContent", 2);
__decorateClass([
  query("[data-join-script-url]")
], ShopCustomJoin.prototype, "joinScriptTarget", 2);
__decorateClass([
  query("#join-remember-checkbox")
], ShopCustomJoin.prototype, "rememberCheckbox", 2);
__decorateClass([
  on("click", "[data-consent-button]")
], ShopCustomJoin.prototype, "handleConsentClick", 1);
ShopCustomJoin = __decorateClass([
  defineElement("shop-custom-join")
], ShopCustomJoin);
export {
  ShopCustomJoin
};
